/**
 * EspoCRM returns timestamps as "YYYY-MM-DD HH:MM:SS" in UTC without timezone
 * indicator. Normalize to ISO 8601 with Z suffix so JS treats them as UTC and
 * toLocaleString converts to the browser's local timezone.
 */
function parseDate(dateStr: string): Date {
  // "2026-04-12 16:16:53" → "2026-04-12T16:16:53Z"
  const normalized = dateStr.includes(" ")
    ? dateStr.replace(" ", "T") + "Z"
    : dateStr;
  return new Date(normalized);
}

/** Format a date string (YYYY-MM-DD or ISO) to Italian locale: "09/04/2026" */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return "—";
  const d = parseDate(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

/** Format a "YYYY-MM" string to Italian month name: "Maggio 2026" */
export function formatMonth(monthStr: string): string {
  const [year, month] = monthStr.split("-").map(Number);
  const d = new Date(year, month - 1, 1);
  return d.toLocaleDateString("it-IT", { month: "long", year: "numeric" });
}

/** Format an ISO timestamp to Italian date + time: "09/04/2026, 14:30" */
export function formatDateTime(dateStr: string | null | undefined): string {
  if (!dateStr) return "—";
  const d = parseDate(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
